import { render } from "./List.vue?vue&type=template&id=46ade92e&scoped=true"
import script from "./List.vue?vue&type=script&lang=ts"
export * from "./List.vue?vue&type=script&lang=ts"

import "./List.vue?vue&type=style&index=0&id=46ade92e&lang=less&scoped=true"
import "./List.vue?vue&type=style&index=1&id=46ade92e&lang=less"
script.render = render
script.__scopeId = "data-v-46ade92e"

export default script